import * as types from "@common/components/steppers/store/steppers.actionType";

export default {
  setActiveStep: data => ({
    type: types.SET_ACTIVE_STEP,
    payload: data
  }),
  setSteps: data => ({
    type: types.SET_STEPS,
    payload: data
  }),
  nextStep: data => ({
    type: types.NEXT_STEP,
    payload: data
  }),
  backStep: data => ({
    type: types.BACK_STEP,
    payload: data
  }),
  goToStep: data => ({
    type: types.GO_TO_STEP,
    payload: data
  }),
  setInitialRender: data => ({
    type: types.SET_INITIAL_RENDER,
    payload: data
  })
};
